var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_telegram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F\\u5907\\u4EFD",
    transform: "translate(-1197.000000, -3150.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4F4D\\u56FE\\u5907\\u4EFD",
    transform: "translate(0.000000, 3110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14",
    transform: "translate(1031.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_telegram",
    transform: "translate(166.009883, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 39.985176,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.992588,0.625 C9.29342959,0.625 0.624768376,9.296875 0.624768376,20 C0.624768376,30.703125 9.29342959,39.375 19.992588,39.375 C30.6917464,39.375 39.3604077,30.703125 39.3604077,20 C39.3604077,9.296875 30.6917464,0.625 19.992588,0.625 Z M29.5046865,13.8984375 L26.3261774,28.8828125 C26.0918893,29.9453125 25.4593113,30.203125 24.576826,29.703125 L19.7348711,26.1328125 L17.3997993,28.3828125 C17.1420823,28.640625 16.9234134,28.859375 16.4235987,28.859375 L16.7672213,23.9296875 L25.7404571,15.8203125 C26.1309373,15.4765625 25.6545514,15.28125 25.1391175,15.625 L14.0494788,22.609375 L9.27000077,21.1171875 C8.23132335,20.7890625 8.20789453,20.078125 9.4886697,19.578125 L28.1614345,12.375 C29.0283006,12.0625 29.7858323,12.5859375 29.5046865,13.8984375 Z",
    id: "\\u5F62\\u72B6",
    fill: "#DBA45C"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTelegram);
export default __webpack_public_path__ + "static/media/ic_telegram.295246a1c31c266d5beb0ed5040167bc.svg";
export { ForwardRef as ReactComponent };